/**
 * Single place for how the SPA reaches the API in dev vs prod.
 * - Dev + local API: prefer same-origin `/api` (Vite proxy) over `http://localhost:4000/api`.
 * - See `vite.config.ts` `mergeMonorepoEnvPlugin` for `.env` at repo root vs `apps/web/`.
 */
export type BrowserApiBaseEnv = {
  VITE_API_BASE_URL?: string;
  DEV: boolean;
};

export function getBrowserApiBase(env?: BrowserApiBaseEnv): string {
  const { VITE_API_BASE_URL: rawBase, DEV } = env ?? {
    VITE_API_BASE_URL: import.meta.env.VITE_API_BASE_URL,
    DEV: import.meta.env.DEV,
  };

  let resolved: string | undefined = rawBase || (DEV ? '/api' : undefined);

  const normalizedBase = rawBase?.trim().replace(/\/+$/, '') ?? '';
  if (DEV && normalizedBase && /^https?:\/\/(localhost|127\.0\.0\.1):4000\/api$/.test(normalizedBase)) {
    resolved = '/api';
  }

  return resolved ?? '';
}
